import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './ModalOverlay.scss';
const ModalOverlay = ({ children, onClose }) => {
    // Create the portal container on the first render
    const container = React.useMemo(() => {
        const el = document.createElement('div');
        return el;
    }, []);
    useEffect(() => {
        const modalRootId = 'modal-root';
        let modalRoot = document.getElementById(modalRootId);
        if (!modalRoot) {
            modalRoot = document.createElement('div');
            modalRoot.setAttribute('id', modalRootId);
            document.body.appendChild(modalRoot);
        }
        modalRoot.appendChild(container);
        // Block background scrolling
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            modalRoot.removeChild(container);
            document.body.style.overflow = originalOverflow;
        };
    }, [container]);
    const stopClickPropagation = (e) => e.stopPropagation();
    const inner = React.isValidElement(children)
        ? React.cloneElement(children, {
            onClick: stopClickPropagation,
        })
        : _jsx("div", { onClick: stopClickPropagation, children: children });
    const content = (_jsx("div", { className: "modal-overlay", onClick: onClose, children: inner }));
    return ReactDOM.createPortal(content, container);
};
export default ModalOverlay;
